import { gql, TypedDocumentNode } from '@common/hooks';
import {
  ApprovalsOrganizationBusinessesQueryQueryCgResponse,
  ApprovalsOrganizationBusinessQueryQueryCgResponse,
  ApprovalsOrganizationBusinessQueryQueryVariables,
  ApprovalsOrganizationUnitQueryQueryCgResponse,
  ApprovalsOrganizationUnitQueryQueryVariables,
  ApprovalsUnitMembershipsQueryQueryCgResponse,
  ApprovalsUnitMembershipsQueryQueryVariables,
} from '@common/graphql';

export const ACTION_TYPE_TITLES = {
  staffing_request_open: 'Staffing Requests',
  extension_offer_active: 'Extension Offers',
};

export type ActionTypeTitlesType = keyof typeof ACTION_TYPE_TITLES;

export type ApprovalsOrganizationBusinessOption =
  ApprovalsOrganizationBusinessesQueryQueryCgResponse['organizationBusinesses'][number];

export const APPROVALS_ORGANIZATION_BUSINESSES_QUERY: TypedDocumentNode<ApprovalsOrganizationBusinessesQueryQueryCgResponse> = gql`
  query ApprovalsOrganizationBusinessesQuery {
    organizationBusinesses {
      id
      name
    }
  }
`;

export type ApprovalTableRowModelType = {
  key: string;
  preApprovedActions: string[];
  isPreApproved: boolean;
  unitId: string;
  unitName: string;
  costCenter: string;
  approvalChainTemplates: ApprovalChainTemplateType[];
  actionTypeKey: ActionTypeTitlesType;
  organizationBusinessId: string;
  organizationBusinessName: string;
  odd: boolean;
  actionTypeTitle?: string;
};

export type ApprovalChainTemplateType = {
  id?: string;
  actionType?: string;
  canShow?: {
    value: boolean;
  };
  approvalChainStepTemplates: ApprovalChainStepTemplateType[];
  destroy?: boolean;
  randomKey?: string;
};

export type ApprovalChainStepTemplateType = {
  approvalChainApproverTemplates: ApprovalChainApproverTemplateType[];
  id?: string;
  destroy?: boolean;
  randomKey?: string;
};

export type ApprovalChainApproverMembershipType = {
  id: string;
  name: string;
};

export type ApprovalChainApproverTemplateType = {
  worksMembership: ApprovalChainApproverMembershipType;
  destroy?: boolean;
  randomKey?: string;
  id?: string;
};

export type ApprovalsOrganizationBusinessType = NonNullable<
  ApprovalsOrganizationBusinessQueryQueryCgResponse['organizationBusiness']
>;

export type ApprovalsOrganizationUnitActiveType =
  ApprovalsOrganizationBusinessType['organizationUnitsActive'][number];

export const APPROVALS_ORGANIZATION_BUSINESS_QUERY: TypedDocumentNode<
  ApprovalsOrganizationBusinessQueryQueryCgResponse,
  ApprovalsOrganizationBusinessQueryQueryVariables
> = gql`
  query ApprovalsOrganizationBusinessQuery($id: ID!) {
    organizationBusiness(id: $id) {
      id
      organizationUnitsActive {
        id
        name
        costCenter
        preapprovalActions
        approvalChainTemplates {
          id
          actionType
          canShow {
            value
          }
          approvalChainStepTemplates {
            id
            approvalChainApproverTemplates {
              id
              worksMembership {
                id
                name
              }
            }
          }
        }
      }
    }
  }
`;

export const APPROVALS_UNIT_MEMBERSHIPS_QUERY: TypedDocumentNode<
  ApprovalsUnitMembershipsQueryQueryCgResponse,
  ApprovalsUnitMembershipsQueryQueryVariables
> = gql`
  query ApprovalsUnitMembershipsQuery($id: ID!) {
    organizationUnit(uuid: $id) {
      id
      department {
        id
        worksMemberships {
          id
          name
        }
      }
    }
  }
`;

export const APPROVALS_ORGANIZATION_UNIT_QUERY: TypedDocumentNode<
  ApprovalsOrganizationUnitQueryQueryCgResponse,
  ApprovalsOrganizationUnitQueryQueryVariables
> = gql`
  query ApprovalsOrganizationUnitQuery($id: ID!) {
    organizationUnit(uuid: $id) {
      id
      name
      costCenter
      preapprovalActions
      approvalChainTemplates {
        id
        actionType
        canShow {
          value
        }
        approvalChainStepTemplates {
          id
          approvalChainApproverTemplates {
            id
            worksMembership {
              id
              name
            }
          }
        }
      }
    }
  }
`;
